import { Injectable } from '@angular/core';
import { LoginIntl } from '@ebootis/login';
import { TranslateService } from '@ngx-translate/core';


@Injectable({
	providedIn: 'root'
})
export class LoginI18n extends LoginIntl {

	public constructor(
		private m_translateService: TranslateService
	) {
		super();
		this.m_translateService.onLangChange.subscribe({
			next: (e: Event) => {
				this.getAndInitTranslations();
			}
		});
		this.getAndInitTranslations();
	}

	private getAndInitTranslations(): void {
		this.m_translateService.get('LOGIN.UI.TITLE.TEXT').subscribe({
			next: (res: string) => {
				this.titleText = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('LOGIN.UI.FORM.USER.PLACEHOLDER').subscribe({
			next: (res: string) => {
				this.userPlaceholder = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('LOGIN.UI.FORM.USER.ERROR.REQUIRED').subscribe({
			next: (res: string) => {
				this.userErrorRequired = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('LOGIN.UI.FORM.PASSWORD.PLACEHOLDER').subscribe({
			next: (res: string) => {
				this.passwordPlaceholder = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('LOGIN.UI.FORM.PASSWORD.ERROR.REQUIRED').subscribe({
			next: (res: string) => {
				this.passwordErrorRequired = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('LOGIN.2FA.UI.DESCRIPTION_QRCODE.TEXT').subscribe({
			next: (res: string) => {
				this.qrcodeDescriptionText = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('LOGIN.2FA.UI.DESCRIPTION_SECRET.TEXT').subscribe({
			next: (res: string) => {
				this.secretDescriptionText = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('LOGIN.2FA.UI.FORM.AUTH_CODE.PLACEHOLDER').subscribe({
			next: (res: string) => {
				this.authcodePlaceholder = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('LOGIN.2FA.UI.FORM.AUTH_CODE.ERROR.REQUIRED').subscribe({
			next: (res: string) => {
				this.authcodeErrorRequired = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('LOGIN.2FA.UI.FORM.AUTH_CODE.ERROR.MIN_LENGTH').subscribe({
			next: (res: string) => {
				this.authcodeErrorMinlength = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('LOGIN.2FA.UI.FORM.TRUSTED_DEVICE.TEXT').subscribe({
			next: (res: string) => {
				this.trustedDeviceText = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('LOGIN.2FA.UI.FORM.DEVICE_NAME.PLACEHOLDER').subscribe({
			next: (res: string) => {
				this.deviceNamePlaceholder = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('LOGIN.2FA.UI.FORM.DEVICE_NAME.ERROR.REQUIRED').subscribe({
			next: (res: string) => {
				this.deviceNameErrorRequired = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('GLOBAL.BUTTON.LOGIN.TEXT').subscribe({
			next: (res: string) => {
				this.loginButtonText = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('LOGIN.UI.BUTTON.PASSWORT_RESET.TEXT').subscribe({
			next: (res: string) => {
				this.passwortResetButtonText = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('LOGIN.2FA.UI.BUTTON.RESET.TEXT').subscribe({
			next: (res: string) => {
				this.tfaResetButtonText = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('LOGIN.2FA.UI.BUTTON.CODE.TEXT').subscribe({
			next: (res: string) => {
				this.tfaScratchcodeButtonText = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('LOGIN.2FA.UI.NO_AUTH_APP.TITLE').subscribe({
			next: (res: string) => {
				this.noAuthAppTitle = res;
				this.changes.next(null);
			}
		});
	}
}
